import { Menu as AntdMenu } from "antd";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getRoutes } from "../../../../routes/Routes";

const Menu = ({ onMenuClick }) => {
    const location = useLocation();

    const { user } = useSelector((state) => state.authSlice);

    const routes = getRoutes();

    const allEntries = Object.entries(routes);

    const canAccess = (route) =>
        !route.allowedRoles || route.allowedRoles.includes(user?.role);

    const flatItems = allEntries
        .filter(([, route]) => route?.icon && !route.group && canAccess(route))
        .map(([, route]) => ({
            key: route.path,
            icon: route.icon,
            label: <Link onClick={onMenuClick} to={route.path}>{route.name}</Link>,
            menuOrder: route.menuOrder ?? 0,
        }));

    const groupParents = allEntries.filter(([, route]) => route.groupParent);

    const groupedItems = groupParents
        .map(([, parent]) => {
            if (!canAccess(parent)) return null;

            const children = allEntries
                .filter(([, route]) => route.group === parent.group && canAccess(route))
                .map(([, route]) => ({
                    key: route.path,
                    icon: route.icon,
                    label: <Link onClick={onMenuClick} to={route.path}>{route.name}</Link>,
                }));

            if (children.length === 0) return null;

            return {
                key: `${parent.group}-group`,
                icon: parent.icon,
                label: parent.name,
                children,
                menuOrder: parent.menuOrder ?? 0,
            };
        })
        .filter(Boolean);

    // Sort flat and grouped items together by menuOrder
    const menuItems = [...flatItems, ...groupedItems]
        .sort((a, b) => a.menuOrder - b.menuOrder)
        .map(({ menuOrder: _, ...item }) => item);

    const activePage = '/' + (location?.pathname?.split('/')[1] || '');

    return (
        <AntdMenu
            mode="inline"
            selectedKeys={[activePage]}
            theme="light"
            style={{ height: '100%', borderRight: 'none' }}
            items={menuItems}
        />
    );
};

export default Menu;